import ELEMENT_ID from "consts/element-ids";
import {
  useGetConfirmModalState,
  useSetConfirmModalState
} from "redux/confirmModal/confirmModalSlice";

import CrudModal from "components/CrudModal";
import { convertBreakToHtml } from "utils";

const ConfirmModal: () => JSX.Element = () => {
  const {
    isOpen,
    title,
    message,
    cancelBtnLabel,
    okBtnLabel,
    isDeleteConfirm,
    isNoAction,
    isConvertBreak
  } = useGetConfirmModalState();
  const { closeConfirmModal } = useSetConfirmModalState();
  const onOk = () => {
    const el = document.getElementById(ELEMENT_ID.CONFIRM_MODAL_OK_BUTTON);
    if (el) {
      el.click();
    }
    closeConfirmModal();
  };

  return (
    <>
      <CrudModal
        isOpen={isOpen}
        handleClose={isNoAction ? undefined : closeConfirmModal}
        handleSave={onOk}
        cancelBtnLabel={cancelBtnLabel}
        saveBtnLabel={okBtnLabel}
        formTitle={title}
        dialogProps={{
          fullWidth: true,
          maxWidth: "sm"
        }}
      >
        <div
          style={{
            padding: "16px 0px",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px"
          }}
          dangerouslySetInnerHTML={{
            __html: isConvertBreak ? message : convertBreakToHtml(message)
          }}
        />
      </CrudModal>

      <div id={ELEMENT_ID.CONFIRM_MODAL_OK_BUTTON} hidden />
    </>
  );
};

export default ConfirmModal;
